import { createAction } from 'typesafe-actions';

import { ADD, REMOVE, SET, SET_DOMAIN, UPDATE } from './constants';

const add = createAction(ADD, (payload: Data.ProducedActivity) => payload)();

const update = createAction(
  UPDATE,
  (payload: PartialWithId<Data.ProducedActivity>) => payload,
)();

const remove = createAction(REMOVE, (payload: string) => payload)();

const set = createAction(SET, (payload: Data.ProducedActivity) => payload)();

const setDomain = createAction(
  SET_DOMAIN,
  (payload: NormalizedDomain<Data.ProducedActivity>) => payload,
)();

export { add, remove, set, setDomain, update };
